/* COLLAPSE · Page produit : la galerie devient une grande fiche HUD (même dessin que les fiches du Drop, collapse-hud.js).
   Une fiche par photo ; flèches (et glissé au doigt) pour passer à la suivante : la fiche visible part en cendres et se
   reforme en l'autre (même métamorphose que le Drop de l'accueil). Première apparition : formation depuis les cendres.
   Sans JavaScript ou mouvement réduit : la photo s'affiche directement, les flèches changent de vue sans animation. */
import { loadImage, cardSizes, drawCard } from './collapse-hud.js?v=tight2';   // version : la ligne d'infos propre à la pièce

const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const MOBILE = matchMedia('(max-width: 900px)');
const MORPH = 1800;          // durée de la métamorphose
const FORM = 1400;           // première apparition (formation depuis les cendres)
const AUTO = 6000;           // défilement automatique des vues : une nouvelle vue toutes les 6 s (après la fin de la bascule)
const PAUSE = 12000;         // après une action du visiteur (flèches, glissé), le défilement reprend 12 s plus tard
const rand = (a, b) => a + Math.random() * (b - a);
const clamp01 = (x) => Math.min(1, Math.max(0, x));
const smooth = (x) => { x = clamp01(x); return x * x * (3 - 2 * x); };
const easeInOut = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);

function fontsFor() {
  const sub = (getComputedStyle(document.documentElement).getPropertyValue('--font-subheading--family') || '').trim();
  const fonts = { label: (sub ? sub + ', ' : '') + 'sans-serif', name: "GFSDidot, 'CollapseGreek', Georgia, serif" };
  const ready = document.fonts
    ? Promise.all([document.fonts.load('400 34px ' + fonts.label), document.fonts.load('700 40px ' + fonts.label), document.fonts.load('400 64px GFSDidot'), document.fonts.load("400 64px 'CollapseGreek'")]).catch(() => {})
    : Promise.resolve();
  return { fonts, ready };
}

// Grains : couleurs de TOUTE la fiche (cadre, marbre, pièce, textes), parties transparentes écartées.
// Calculés une fois par fiche, réutilisés à chaque bascule.
function sample(cv, n) {
  if (cv.__pts) return cv.__pts;
  const cols = 72, rows = 90, c = document.createElement('canvas');
  c.width = cols; c.height = rows;
  const g = c.getContext('2d', { willReadFrequently: true });
  g.drawImage(cv, 0, 0, cols, rows);
  const d = g.getImageData(0, 0, cols, rows).data, out = [];
  for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) {
    const o = (j * cols + i) * 4;
    if (d[o + 3] < 60) continue;
    const k = 0.7;    // fond de marbre noir : grains gris cendre, ni blancs sur le noir, ni sombres sur la fiche
    out.push({ u: (i + Math.random()) / cols, v: (j + Math.random()) / rows, c: [d[o] * k, d[o + 1] * k, d[o + 2] * k] });
  }
  for (let k = out.length - 1; k > 0; k--) { const j = (Math.random() * (k + 1)) | 0; [out[k], out[j]] = [out[j], out[k]]; }
  // appariement cohérent entre deux fiches : ordre de haut en bas (avec du bruit)
  return (cv.__pts = out.slice(0, n).map((p) => Object.assign(p, { k: p.v + (p.u - 0.5) * 0.2 + Math.random() * 0.14 })).sort((a, b) => a.k - b.k));
}
// Palette réduite : 24 gris chauds + 6 rouges ; les grains d'une même teinte sont dessinés d'un seul trait (fluide sur téléphone).
const GREYS = 24, REDS = 6, PAL = [];
for (let i = 0; i < GREYS; i++) { const v = Math.round(i * 235 / (GREYS - 1)); PAL.push(`rgb(${v},${Math.round(v * 0.985)},${Math.round(v * 0.95)})`); }
for (let i = 0; i < REDS; i++) { const v = 0.45 + 0.55 * i / (REDS - 1); PAL.push(`rgb(${Math.round(200 * v)},${Math.round(60 * v)},${Math.round(45 * v)})`); }
const palIdx = (c) => {
  const lum = 0.3 * c[0] + 0.59 * c[1] + 0.11 * c[2];
  if (c[0] - Math.max(c[1], c[2]) > 45) return GREYS + Math.max(0, Math.min(REDS - 1, Math.round((c[0] / 200 - 0.45) / 0.55 * (REDS - 1))));
  return Math.max(0, Math.min(GREYS - 1, Math.round(lum / 235 * (GREYS - 1))));
};
const ALPHAS = [0.35, 0.7, 1];
const buckets = Array.from({ length: PAL.length * ALPHAS.length }, () => []);

// Métamorphose en cendres (comme le Drop de l'accueil) : chaque grain quitte un point de la fiche visible et rejoint
// un point de l'autre, sa couleur passant de l'une à l'autre. Première apparition : les grains montent de sous la fiche.
// Fond de marbre noir : les fiches restent toujours opaques. La nouvelle se dévoile de haut en bas (bord irrégulier)
// là où les grains se posent, l'ancienne disparaît au même endroit : jamais de fiche grise ni de fantôme.
function ashSwap(dc, from, to, dur) {
  return new Promise((done) => {
    const host = dc.querySelector('.clp-dc__float') || dc;
    const W = host.clientWidth, H = host.clientHeight;
    const finish = () => { if (from) { from.classList.remove('is-on'); from.style.zIndex = ''; from.style.clipPath = ''; } to.classList.add('is-on'); to.style.opacity = ''; to.style.clipPath = ''; to.style.zIndex = ''; dc.classList.remove('is-swapping'); };
    if (!W || !H || !to.__cv) { finish(); return done(); }
    const PAD = 0.25, pr = Math.min(1.5, devicePixelRatio || 1), CW = W * (1 + 2 * PAD), CH = H * (1 + 2 * PAD);
    const cv = document.createElement('canvas');
    cv.className = 'clp-dc__ash';
    // (max-width : la règle générale du thème « canvas { max-width:100% } » rétrécissait la toile → grains en haut à gauche)
    Object.assign(cv.style, { left: -W * PAD + 'px', top: -H * PAD + 'px', width: CW + 'px', height: CH + 'px', maxWidth: 'none', maxHeight: 'none', zIndex: 4 });
    cv.width = Math.round(CW * pr); cv.height = Math.round(CH * pr);
    host.appendChild(cv);
    const g = cv.getContext('2d');
    g.scale(pr, pr);
    const ox = W * PAD, oy = H * PAD;
    const N = MOBILE.matches ? 1800 : 2600;
    // les deux fiches sont déjà triées de haut en bas : le i-ème grain de l'une rejoint le i-ème de l'autre
    const pick = (arr) => { const out = [], st = arr.length / N; for (let i = 0; i < N && i * st < arr.length; i++) out.push(arr[Math.floor(i * st)]); return out; };
    const B = pick(sample(to.__cv, 4000));
    const A = from && from.__cv ? pick(sample(from.__cv, 4000)) : null;
    const pts = B.map((b, i) => {
      const bx = ox + b.u * W, by = oy + b.v * H;
      let ax, ay, ca;
      if (A) { const a = A[Math.floor(i * A.length / B.length)]; ax = ox + a.u * W; ay = oy + a.v * H; ca = a.c; }
      else { ax = bx + rand(-0.5, 0.5) * W * 0.6; ay = oy + H + rand(0.05, 0.5) * H * 0.5; ca = b.c; }
      const cols = [];
      for (let s = 0; s <= 5; s++) cols.push(palIdx([0, 1, 2].map((q) => ca[q] + (b.c[q] - ca[q]) * s / 5)));
      // départ échelonné : le haut de la fiche se défait en premier, avec du désordre
      const d = (A ? 0.26 : 0.3) * clamp01(b.v * 0.7 + Math.random() * 0.3);
      return { ax, ay, bx, by, cols, d, sw: rand(-1, 1), s: rand(0.9, 1.9) };
    });
    const LIFE = A ? 0.66 : 0.62;
    const seed = Math.random() * 10, NSEG = 24;
    // bord de dévoilement : suit l'arrivée des grains (haut d'abord), légèrement irrégulier
    const edge = (u, r, t) => r * 1.12 - 0.06 + (Math.sin(u * 13 + seed + t * 2.2) * 0.5 + Math.sin(u * 31 - t * 3.1) * 0.3 + Math.sin(u * 5.3 + seed * 2) * 0.6) * 0.02;
    to.style.opacity = '1'; to.style.zIndex = '2'; to.style.clipPath = 'inset(0 0 100% 0)';
    to.classList.add('is-on');
    if (from) from.style.zIndex = '1';
    dc.classList.add('is-swapping');
    const t0 = performance.now();
    const step = (now) => {
      const x = (now - t0) / dur, ts = (now - t0) / 1000;
      g.clearRect(0, 0, CW, CH);
      // fiches : nouvelle au-dessus du bord, ancienne en dessous (toutes deux opaques)
      const r = smooth((x - (A ? 0.34 : 0.3)) / 0.6), line = [];
      for (let i = NSEG; i >= 0; i--) { const u = i / NSEG; line.push((u * 100).toFixed(2) + '% ' + (Math.max(0, Math.min(1.02, edge(u, r, ts))) * 100).toFixed(2) + '%'); }
      to.style.clipPath = 'polygon(0% 0%,100% 0%,' + line.join(',') + ')';
      if (from) from.style.clipPath = 'polygon(' + line.join(',') + ',0% 102%,100% 102%)';
      // grains
      for (const p of pts) {
        const s = clamp01((x - p.d) / LIFE);
        if (s <= 0 || s >= 1) continue;
        const e = easeInOut(s), arc = Math.sin(Math.PI * s);
        const al = Math.min(1, s * 8) * (1 - smooth((s - 0.82) / 0.18));
        p.px = p.ax + (p.bx - p.ax) * e + p.sw * arc * W * 0.14;
        p.py = p.ay + (p.by - p.ay) * e - arc * H * 0.05 + Math.cos(Math.PI * s * 2) * p.sw * 3;
        p.pz = p.s * (1 + 0.4 * arc);
        buckets[p.cols[Math.round(e * 5)] * ALPHAS.length + (al > 0.85 ? 2 : al > 0.5 ? 1 : 0)].push(p);
      }
      for (let k = 0; k < buckets.length; k++) {
        const bk = buckets[k];
        if (!bk.length) continue;
        g.globalAlpha = ALPHAS[k % ALPHAS.length];
        g.fillStyle = PAL[(k / ALPHAS.length) | 0];
        g.beginPath();
        for (const p of bk) g.rect(p.px, p.py, p.pz, p.pz);
        g.fill();
        bk.length = 0;
      }
      g.globalAlpha = 1;
      if (x < 1) return requestAnimationFrame(step);
      cv.remove();
      finish();
      done();
    };
    requestAnimationFrame(step);
  });
}

function initGallery(gal) {
  let data;
  try { data = JSON.parse(gal.querySelector('[data-clp-gal]').textContent); } catch (e) { return; }
  const dc = gal.querySelector('[data-clp-gal-card]');
  const layers = [...gal.querySelectorAll('.clp-dc__l')];
  if (!dc || !layers.length) return;
  const cnt = gal.querySelector('[data-count]'), prev = gal.querySelector('[data-prev]'), next = gal.querySelector('[data-next]');
  const pad = (n) => String(n).padStart(2, '0');
  const { fonts, ready } = fontsFor();
  const hi = (u) => (u && u.startsWith('//') ? location.protocol + u : u);
  // Résolution : largeur affichée de la fiche × densité réelle de l'écran (fiche nette), comme sur l'accueil.
  const S = Math.min(2, Math.max(0.5, (Math.max(dc.getBoundingClientRect().width, 360) * Math.min(3, devicePixelRatio || 1)) / 1024));
  const prod = { t: data.t, p: data.p };
  let sizes = null, marble = null, cur = 0, busy = false, queued = null, shown = false, onScreen = false, swappedAt = 0, userAt = -1e9;

  // Dessin d'une fiche (une par photo), à la demande ; la première tout de suite, les autres pendant les temps morts.
  const paintOne = (i) => {
    const l = layers[i];
    if (l.__p) return l.__p;
    l.__p = loadImage(hi(data.imgs[i].u)).then((img) => new Promise((res) => {
      const idle = window.requestIdleCallback || ((f) => setTimeout(f, 30));
      idle(() => {
        try {
          const p = Object.assign({}, prod, { label: data.imgs[i].l, spec: data.spec, tight: true });
          const c = drawCard(p, i, layers.length, img, marble, fonts, sizes, S);
          c.setAttribute('aria-hidden', 'true');
          l.__cv = c;
          l.appendChild(c);
          l.classList.add('is-painted');
          (window.requestIdleCallback || ((f) => setTimeout(f, 50)))(() => sample(c, 4000));
        } catch (e) { console.error('[fiche produit]', e); }
        res();
      }, { timeout: 800 });
    })).catch(() => null);
    return l.__p;
  };
  const base = Promise.all([loadImage(data.marble).catch(() => null), ready]).then(([m]) => { marble = m; sizes = cardSizes([prod], fonts); });

  function reveal() {
    if (shown || !onScreen || !layers[cur].__cv) return;
    shown = true;
    dc.classList.add('is-ready');
    if (REDUCED) { layers[cur].style.opacity = ''; return; }
    busy = true;
    ashSwap(dc, null, layers[cur], FORM).then(() => { busy = false; swappedAt = performance.now(); after(); });
  }
  base.then(() => paintOne(0)).then(() => {
    if (!layers[0].__cv) { dc.classList.add('is-ready'); return; }
    if (!REDUCED && !shown) layers[0].style.opacity = '0';   // cachée jusqu'à sa formation
    reveal();
    layers.slice(1).forEach((l, k) => setTimeout(() => paintOne(k + 1), 400 + k * 250));
  });
  new IntersectionObserver((en) => { onScreen = en[0].isIntersecting; dc.classList.toggle('is-idle', !onScreen); if (onScreen) reveal(); }, { threshold: 0.3 }).observe(dc);

  function after() { if (queued !== null) { const q = queued; queued = null; if (q !== cur) go(q); } }
  async function go(i) {
    if (layers.length < 2) return;
    i = (i + layers.length) % layers.length;
    if (busy) { queued = i; if (cnt) cnt.textContent = pad(i + 1) + ' / ' + pad(layers.length); return; }
    const from = layers[cur], to = layers[i];
    cur = i;
    if (cnt) cnt.textContent = pad(i + 1) + ' / ' + pad(layers.length);
    await paintOne(i);
    if (REDUCED || !shown || !to.__cv || !from.__cv) { from.classList.remove('is-on'); from.style.opacity = ''; to.classList.add('is-on'); to.style.opacity = ''; swappedAt = performance.now(); return; }
    busy = true;
    await ashSwap(dc, from, to, MORPH);
    busy = false;
    swappedAt = performance.now();
    after();
  }
  // toucher / cliquer la fiche : la photo s'ouvre en plein écran, agrandissable (toucher pour zoomer, pincer, glisser)
  let swiped = false;
  dc.addEventListener('click', () => { if (swiped) { swiped = false; return; } openZoom(data.imgs[cur], data.t); });
  if (prev) prev.addEventListener('click', () => { userAt = performance.now(); go(cur - 1); });
  if (next) next.addEventListener('click', () => { userAt = performance.now(); go(cur + 1); });
  // défilement automatique : face → dos → côté… en boucle, seulement quand la fiche est visible et que la page est au premier plan
  if (!REDUCED && layers.length > 1) setInterval(() => {
    const t = performance.now();
    if (!shown || busy || !onScreen || document.hidden || (zoomEl && !zoomEl.hidden)) return;
    if (t - userAt < PAUSE || t - swappedAt < AUTO) return;
    const n = (cur + 1) % layers.length;
    if (!layers[n].__cv) { paintOne(n); return; }
    go(n);
  }, 300);
  // glisser au doigt sur la fiche (mobile)
  let sx = null, sy = 0;
  dc.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  dc.addEventListener('touchend', (e) => {
    if (sx === null) return;
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    sx = null;
    swiped = Math.abs(dx) > 12 || Math.abs(dy) > 12;
    if (swiped) userAt = performance.now();
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(cur + (dx < 0 ? 1 : -1));
  }, { passive: true });
}

// Visionneuse plein écran : photo en haute définition ; un toucher zoome (×2,5) à l'endroit touché, un autre dézoome.
let zoomEl = null, zoomBack = null;
function openZoom(im, title) {
  if (!im || !im.u) return;
  if (!zoomEl) {
    zoomEl = document.createElement('div');
    zoomEl.className = 'clp-zoom'; zoomEl.hidden = true;
    zoomEl.setAttribute('role', 'dialog'); zoomEl.setAttribute('aria-modal', 'true');
    zoomEl.innerHTML = '<button type="button" class="clp-zoom__x" aria-label="Fermer">&times;</button><img class="clp-zoom__img" alt=""><p class="clp-zoom__hint">Touchez pour zoomer</p>';
    const img = zoomEl.querySelector('img');
    zoomEl.querySelector('.clp-zoom__x').addEventListener('click', closeZoom);
    img.addEventListener('click', (e) => {
      const r = img.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      const big = zoomEl.classList.toggle('is-big');
      if (big) { const r2 = img.getBoundingClientRect(); zoomEl.scrollLeft = fx * r2.width - innerWidth / 2; zoomEl.scrollTop = fy * r2.height - innerHeight / 2; }
      else { zoomEl.scrollLeft = 0; zoomEl.scrollTop = 0; }
      zoomEl.querySelector('.clp-zoom__hint').hidden = true;
    });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && zoomEl && !zoomEl.hidden) closeZoom(); });
    document.body.appendChild(zoomEl);
  }
  const img = zoomEl.querySelector('img');
  const u = im.u.startsWith('//') ? location.protocol + im.u : im.u;
  img.src = /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/,(m, a) => a + '2000') : u;
  img.alt = (title || '') + (im.l ? ' — ' + im.l : '');
  zoomEl.classList.remove('is-big');
  zoomEl.querySelector('.clp-zoom__hint').hidden = false;
  zoomBack = document.activeElement;
  zoomEl.hidden = false;
  document.documentElement.style.overflow = 'hidden';
  zoomEl.querySelector('.clp-zoom__x').focus();
}
function closeZoom() {
  zoomEl.hidden = true;
  document.documentElement.style.overflow = '';
  if (zoomBack && zoomBack.focus) zoomBack.focus();
}

function boot(scope) {
  scope.querySelectorAll('.clp-gal:not([data-clp-gal-on])').forEach((gal) => {
    gal.setAttribute('data-clp-gal-on', '');
    try { initGallery(gal); } catch (e) { console.error('[fiche produit]', e); }
  });
}
if (document.readyState === 'loading') addEventListener('DOMContentLoaded', () => boot(document), { once: true }); else boot(document);
document.addEventListener('shopify:section:load', (e) => boot(e.target));